import React, { useEffect, Fragment, useState } from "react"
import { withStyles } from "@material-ui/core/styles"
import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  Button,
  InputBase,
  IconButton,
  Switch,
  CircularProgress
} from "@material-ui/core/"
import { Pagination } from "@material-ui/lab"
import styles from "./styles"
import AdminHeader from "components/AdminHeader"
import ActionBar from "components/ActionBar"
import API from "store/api"
import SearchIcon from "@material-ui/icons/Search"
import { useSelector } from "react-redux"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp"
import { openCreateOrganizationDialog } from "actions/create-organization-dialog"
import { useDispatch } from "react-redux"
import CreateGroup from "./createGroup"
import DeleteOrg from "./deleteOrg"
import DeleteIcon from "@material-ui/icons/Delete"
import { updateWhiteLabeled } from "actions/organization"

const sorts = [
  {
    name: "Org. Name",
    getVal: val => val.name
  },
  {
    name: "Group Code",
    getVal: val => val.group_code_id
  },
  {
    name: "City",
    getVal: val => val.address.city
  },
  {
    name: "State",
    getVal: val => val.address.state
  },
  {
    name: "ZIP",
    getVal: val => val.address.zip
  },
  {
    name: "First Name",
    getVal: val => val.acc_first_name
  },
  {
    name: "Last Name",
    getVal: val => val.acc_last_name
  },
  {
    name: "Phone",
    getVal: val => val.phone
  },
  {
    name: "Email",
    getVal: val => val.email
  },
  {
    name: "Members",
    getVal: val => val.user_count
  },
  {
    name: "Subsciption Tier",
    getVal: val => val.plan
  },
  {},
  {},
  {
    name: "White Label"
  }
]

function formatPhoneNumber(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "")
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return ["(", match[2], ") ", match[3], " - ", match[4]].join("")
  }
  return null
}

const SuperAdmin = ({ classes }) => {
  const dispatch = useDispatch()
  const [wholeOrganizationsList, setWholeOrganizationsList] = useState([])
  const [organizationsPerPage, setOrganizationsPerPage] = useState([])
  const [numberOfOrganizations, setNumberOfOrganizations] = useState()
  const [page, setPage] = useState(1)
  const organizationPerPage = 10
  let indexOfLastOrganization = page * organizationPerPage
  let indexOfFirstOrganization = indexOfLastOrganization - organizationPerPage
  const { token, user } = useSelector(state => ({
    token: state.authentication.token,
    user: state.authentication.authenticatedUser
  }))
  const [sort, setSort] = useState(null)
  const [searchFilter, setSearchFilter] = useState("")
  const [filteredOrganizations, setFilteredOrganizations] = useState([])
  const [plans, setPlans] = useState([])
  const [groupCodes, setGroupCodes] = useState([])
  const [createGroupOpen, setCreateGroupOpen] = useState(false)
  const [createGroupOrg, setCreateGroupOrg] = useState(false)
  const [deleteOrg, setDeleteOrg] = useState(null)
  const [switchValue, setSwitchValue] = useState([])
  const [changingSwitch, setChangingSwitch] = useState([])

  const handleSearch = e => {
    const searchValue = e.target.value
    setSearchFilter(searchValue)
  }

  const loadOrgs = () => {
    API.get("/stripe/listPlans")
      .then(res => {
        const plans = res.body.plans
        setPlans(plans)
      })
      .catch(err => {
        console.log(err)
      })

    API.get("/groupCodes")
      .then(res => {
        const codes = res.body.codes
        setGroupCodes(codes)
      })
      .catch(err => {
        console.log(err)
      })

    API.get(`/admin/orgs`)
      .then(res => {
        const data = res.body.data.map(x => {
          try {
            x.address = JSON.parse(x.address)
          } catch (err) {
            console.log(err)
            x.addres = {}
          }
          return x
        })
        setWholeOrganizationsList(data)
        setSwitchValue(
          data.map(x => {
            return {
              id: x.id,
              labeled: x.white_labeled
            }
          })
        )
        setChangingSwitch(
          data.map(x => {
            return {
              id: x.id,
              loading: false
            }
          })
        )
      })
      .catch(error => {
        console.log(error)
      })
  }

  useEffect(() => {
    loadOrgs()
  }, [])

  useEffect(() => {
    setOrganizationsPerPage(
      wholeOrganizationsList.slice(
        indexOfFirstOrganization,
        indexOfLastOrganization
      )
    )
    setNumberOfOrganizations(wholeOrganizationsList.length)
  }, [page, wholeOrganizationsList])

  const searchOrganizations = () => {
    const searchRegExp = new RegExp(searchFilter, "i")
    let matches = wholeOrganizationsList.filter(organization => {
      const organizationName = organization.name
      const organizationAddress =
        organization && organization.address && organization.address.address
          ? organization.address.address
          : ""
      /* eslint-disable */
      const parentCode =
        groupCodes && groupCodes.find(x => x.org_id === organization.id)

      const organizationGroupCode =
        groupCodes && organization.group_code_id
          ? groupCodes.find(x => x.id === organization.group_code_id).code
          : parentCode
          ? parentCode.code
          : ""
      /* eslint-enable */
      const organizationCity =
        organization && organization.address ? organization.address.city : ""
      const organizationState =
        organization && organization.address ? organization.address.state : ""
      const organizationZip =
        organization && organization.address ? organization.address.zip : ""
      const organizationFirstName =
        organization && organization.acc_first_name
          ? organization.acc_first_name
          : ""
      const organizationLastName =
        organization && organization.acc_last_name
          ? organization.acc_last_name
          : ""
      const organizationPhone =
        organization && organization.phone ? organization.phone : ""
      const organizationEmail =
        organization && organization.email ? organization.email : ""
      const organizationMembers =
        organization &&
        organization.organization &&
        organization.organization.user_count
          ? organization.organization.user_count.toString()
          : ""
      const organizationPlan =
        organization && organization.plan ? organization.plan : ""
      return (
        organizationName.search(searchRegExp) > -1 ||
        organizationAddress.search(searchRegExp) > -1 ||
        (organizationGroupCode &&
          organizationGroupCode.search(searchRegExp) > -1) ||
        organizationCity.search(searchRegExp) > -1 ||
        organizationState.search(searchRegExp) > -1 ||
        organizationZip.search(searchRegExp) > -1 ||
        organizationFirstName.search(searchRegExp) > -1 ||
        organizationLastName.search(searchRegExp) > -1 ||
        organizationPhone.search(searchRegExp) > -1 ||
        organizationEmail.search(searchRegExp) > -1 ||
        organizationMembers.search(searchRegExp) > -1 ||
        (organizationPlan && organizationPlan.search(searchRegExp) > -1)
      )
    })
    if (sort && sort.name === "Members") {
      if (sort.dir === "ASC") {
        matches = matches.sort((a, b) => sort.getVal(a) - sort.getVal(b))
      } else {
        matches = matches.sort(
          (a, b) =>
            (matches = matches.sort((a, b) => sort.getVal(b) - sort.getVal(a)))
        )
      }
    }
    if (sort && sort.name !== "Members") {
      if (sort.dir === "ASC") {
        matches = matches.sort((a, b) =>
          ("" + sort.getVal(a)).localeCompare(sort.getVal(b))
        )
      } else {
        matches = matches.sort((a, b) =>
          ("" + sort.getVal(b)).localeCompare(sort.getVal(a))
        )
      }
    }

    setFilteredOrganizations(
      matches.slice(indexOfFirstOrganization, indexOfLastOrganization)
    )
    setNumberOfOrganizations(matches.length)
  }

  useEffect(() => {
    searchOrganizations()
  }, [searchFilter, sort, page])

  const handleOpenView = subdomain => {
    window.location = `${window.location.protocol}//${subdomain}.firstlinesocial.com/admin/settings?token=${token}&user=${user.id}`
  }

  let displayedOrganizations =
    searchFilter || sort ? filteredOrganizations : organizationsPerPage

  const handleSortClick = newSort => {
    if (sort && sort.name === newSort.name) {
      if (sort.dir === "ASC") {
        setSort({ ...newSort, dir: "DESC" })
      } else {
        setSort(null)
      }
    } else {
      setSort({ ...newSort, dir: "ASC" })
    }
  }

  const handleOpenCreateOrganization = () => {
    dispatch(openCreateOrganizationDialog())
  }

  const groupCodeTimesUsed = groupCodeId => {
    let wholeOrganizationListFilter = wholeOrganizationsList.filter(
      element => element.group_code_id === groupCodeId
    )
    return wholeOrganizationListFilter.length
  }

  const handleChagneWhiteLabeled = (id, labeled) => {
    var foundIndex = changingSwitch.findIndex(x => x.id === id)
    setChangingSwitch([
      ...changingSwitch,
      (changingSwitch[foundIndex].loading = true)
    ])
    dispatch(updateWhiteLabeled({ whiteLabeled: labeled }, id))
      .then(() => {
        var foundIndex = switchValue.findIndex(x => x.id === id)
        setSwitchValue([
          ...switchValue,
          (switchValue[foundIndex].labeled = labeled)
        ])
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        var foundIndex = changingSwitch.findIndex(x => x.id === id)
        setChangingSwitch([
          ...changingSwitch,
          (changingSwitch[foundIndex].loading = false)
        ])
      })
  }

  // const { open } = useSelector(state => state.createOrganizationDialog.open)
  return (
    <Box className={classes.superAdminContainer}>
      <AdminHeader />
      <ActionBar
        // sorts={sorts}
        // setSort={setSort}
        // sort={sort}
        searchBar={
          <div className={classes.searchBar}>
            <SearchIcon className={classes.searchIcon} />
            <InputBase
              placeholder="Search"
              className={classes.searchInput}
              onChange={e => handleSearch(e)}
            />
          </div>
        }
      />
      <Box
        className={classes.titleButtonContainer}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Typography
            className={classes.titleContainer}
            variant="h2"
            color="primary"
          >
            Admin Dashboard
          </Typography>
        </Box>
        <Box>
          <Button
            className={classes.createOrganizationButton}
            variant="contained"
            color="primary"
            onClick={handleOpenCreateOrganization}
          >
            Create Organization
          </Button>
        </Box>
      </Box>

      <Box className={classes.tableContainer}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                {sorts &&
                  sorts.map((s, i) => {
                    let content = [s.name]
                    if (sort && sort.name === s.name) {
                      if (sort.dir === "ASC") {
                        content = (
                          <Fragment>
                            {content}
                            <ArrowDropUpIcon className={classes.arrowIcon} />
                          </Fragment>
                        )
                      } else {
                        content = (
                          <Fragment>
                            {content}
                            <ArrowDropDownIcon className={classes.arrowIcon} />
                          </Fragment>
                        )
                      }
                    }
                    return (
                      <TableCell key={i} className={classes.tableCellContainer}>
                        <Typography
                          className={classes.sortContianer}
                          variant="h6"
                          color="primary"
                          onClick={() => handleSortClick(s)}
                        >
                          {content}
                        </Typography>
                      </TableCell>
                    )
                  })}
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedOrganizations &&
                displayedOrganizations.map((org, i) => {
                  const {
                    id,
                    name,
                    address,
                    phone,
                    email,
                    user_count: members,
                    subdomain,
                    acc_first_name: firstName,
                    acc_last_name: lastName,
                    white_labeled: whiteLabeled
                  } = org

                  let plan = "None"
                  plans.map(x => {
                    if (x.id === String(org.plan)) {
                      plan = `${x.nickname}: $${x.amount / 100}`
                    }
                  })

                  let groupCode = org.group_code_id
                  let groupCodeId = org.group_code_id

                  if (!groupCodeId) {
                    groupCodes.map(x => {
                      if (x.org_id === id) {
                        groupCodeId = x.id
                      }
                    })
                  } else {
                    groupCodes.map(x => {
                      if (x.id === groupCodeId) {
                        groupCodeId = x.id
                      }
                    })
                  }

                  if (!groupCode) {
                    // check to see if they own a group code
                    groupCodes.map(x => {
                      if (x.org_id === id) {
                        groupCode = "**" + x.code + "**"
                      }
                    })
                  } else {
                    // set code instead of id
                    groupCodes.map(x => {
                      if (x.id === groupCode) {
                        groupCode = x.code
                        // groupId = x.id
                      }
                    })
                  }
                  return (
                    <TableRow
                      key={i}
                      className={
                        i % 2 === 0 ? classes.cellBackgroundGray : null
                      }
                    >
                      <TableCell
                        className={classes.informationCells}
                        component="th"
                        scope="row"
                      >
                        <Box>
                          <Box className={classes.orgNameContainer}>
                            <Typography variant="h6" color="primary">
                              {name}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography variant="subtitle1" color="primary">
                              {address && address.address
                                ? address.address
                                : ""}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {groupCode ? (
                            groupCode
                          ) : (
                            <Button
                              variant="contained"
                              onClick={() => {
                                setCreateGroupOpen(true)
                                setCreateGroupOrg(org)
                              }}
                              color="primary"
                            >
                              New Group
                            </Button>
                          )}
                          <br />
                          <br />
                          {groupCode && (
                            <Typography>
                              Times used: {groupCodeTimesUsed(groupCodeId)}
                            </Typography>
                          )}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {address && address.city ? address.city : ""}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {address && address.state ? address.state : ""}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {address && address.zip ? address.zip : ""}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {firstName}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {lastName}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {formatPhoneNumber(phone)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {email}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {members}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" color="primary">
                          {plan}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleOpenView(subdomain)
                          }}
                        >
                          View
                        </Button>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() => {
                            setDeleteOrg(org)
                          }}
                        >
                          <DeleteIcon style={{ color: "red" }} />
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <Switch
                            color="primary"
                            disabled={
                              changingSwitch.length > 0 &&
                              changingSwitch.find(x => x.id === org.id)
                                .loading === true
                            }
                            checked={
                              switchValue.find(x => x.id === org.id).labeled ===
                              1
                            }
                            onChange={() =>
                              handleChagneWhiteLabeled(
                                org.id,
                                switchValue.filter(x => x.id === org.id)[0]
                                  .labeled === 1
                                  ? 0
                                  : 1
                              )
                            }
                          />
                          {changingSwitch.length > 0 &&
                            changingSwitch.find(x => x.id === org.id)
                              .loading === true && (
                              <CircularProgress size={10} />
                            )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
        {/* {searchFilter.length === 0 && sort === null && ( */}
        <Box
          className={classes.paginationContainer}
          display="flex"
          justifyContent="center"
        >
          <Pagination
            count={Math.ceil(numberOfOrganizations / organizationPerPage)}
            onChange={(e, p) => {
              setPage(p)
            }}
          />
        </Box>
      </Box>
      <CreateGroup
        open={createGroupOpen}
        close={bool => {
          if (bool) {
            loadOrgs()
          }
          setCreateGroupOpen(false)
          setCreateGroupOrg(false)
        }}
        org={createGroupOrg}
      />
      <DeleteOrg
        open={Boolean(deleteOrg)}
        close={bool => {
          if (bool) {
            loadOrgs()
          }
          setDeleteOrg(null)
        }}
        org={deleteOrg ? deleteOrg : {}}
      />
    </Box>
  )
}

export default withStyles(styles)(SuperAdmin)



// WEBPACK FOOTER //
// ./src/pages/SuperAdmin/index.js